/* unplugin-vue-components disabled */import script from "./BannerTemplate.vue?vue&type=script&setup=true&lang=js"
export * from "./BannerTemplate.vue?vue&type=script&setup=true&lang=js"

import "./BannerTemplate.vue?vue&type=style&index=0&id=0dfd70da&scoped=true&lang=scss"

import exportComponent from "/root/.jenkins/workspace/高保障-门户哈尔滨医科大学-前端页面-saas/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0dfd70da"]])

export default __exports__